import * as React from 'react';
import { Styleable } from '../utils/styles';

import { Button } from './Button';

export interface ButtonAction extends Styleable {
  label: string;
  handler: Function;
}

export const ActionBarItem = (props: ButtonAction) => (
  <div key={props.label} className="mh1 mb2 mb0-ns w-100-s">
    <Button onClick={props.handler} className={props.className}>
      {props.label}
    </Button>
  </div>
);
